module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "ui huge menu"
  }, [_c('a', {
    staticClass: "item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.triggerMenu($event)
      }
    }
  }, [_c('i', {
    staticClass: "content icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "right menu"
  }), _vm._v(" "), _c('a', {
    staticClass: "red item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addUser($event)
      }
    }
  }, [_c('i', {
    staticClass: "plus icon"
  }), _vm._v(" Add User")])]), _vm._v(" "), _c('div', {
    staticClass: "ui container"
  }, [_c('h3', {
    staticClass: "ui header"
  }, [_vm._v("\n      Users\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "ui loader",
    class: {
      'active': _vm.fetching
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "ui table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.users), function(user) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(user.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.email))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "ui label",
      class: [{
        'red': user.role === 'superAdmin',
        'orange': user.role === 'admin',
        'blue': user.role === 'cashier',
        'green': user.role === 'crew'
      }]
    }, [_vm._v(_vm._s(user.role) + "\n          ")])]), _vm._v(" "), _c('td', {
      staticClass: "collapsing"
    }, [_c('div', {
      staticClass: "ui tiny buttons"
    }, [_c('div', {
      staticClass: "ui button",
      on: {
        "click": function($event) {
          _vm.editUser(user)
        }
      }
    }, [_c('i', {
      staticClass: "edit icon"
    }), _vm._v(" Edit User")]), _vm._v(" "), _c('div', {
      staticClass: "ui floating dropdown blue icon button",
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, [_c('i', {
      staticClass: "dropdown icon"
    }), _vm._v(" "), _c('div', {
      staticClass: "menu"
    }, [_c('div', {
      staticClass: "item",
      on: {
        "click": function($event) {
          _vm.editUser(user)
        }
      }
    }, [_c('i', {
      staticClass: "edit icon"
    }), _vm._v(" Edit User")]), _vm._v(" "), _c('div', {
      staticClass: "item",
      on: {
        "click": function($event) {
          _vm.triggerDeleteUser(user)
        }
      }
    }, [_c('i', {
      staticClass: "trash icon"
    }), _vm._v(" Delete User")])])])])])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "ui small basic delete modal"
  }, [_c('div', {
    staticClass: "header",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n      Are you sure?\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n      Delete user "), (_vm.userForDelete) ? _c('strong', [_vm._v(_vm._s(_vm.userForDelete.name))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "actions",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "ui green ok inverted button",
    on: {
      "click": function($event) {
        _vm.deleteUser(_vm.userForDelete)
      }
    }
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v("\n        Yes\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "ui small modal",
    attrs: {
      "id": "userModal"
    }
  }, [_c('i', {
    staticClass: "close icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [(_vm.user._id) ? _c('span', [_vm._v("Edit User")]) : _c('span', [_vm._v("Add User")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('form', {
    staticClass: "ui form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "ui input",
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "ui input",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.name),
      expression: "user.name"
    }],
    staticClass: "ui input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("Role")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.role),
      expression: "user.role"
    }],
    staticClass: "ui selection dropdown",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.user.role = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select User Role...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "crew"
    }
  }, [_vm._v("Crew")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "cashier"
    }
  }, [_vm._v("Cashier")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "sales"
    }
  }, [_vm._v("Sales")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "driver"
    }
  }, [_vm._v("Driver")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "admin"
    }
  }, [_vm._v("Admin")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "superAdmin"
    }
  }, [_vm._v("Super Admin")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "ui icon positive button",
    on: {
      "click": _vm.saveUser
    }
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v(" Save User\n      ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("\n          Name\n        ")]), _vm._v(" "), _c('th', [_vm._v("\n          Email\n        ")]), _vm._v(" "), _c('th', [_vm._v("\n          Role\n        ")]), _vm._v(" "), _c('th', {
    staticClass: "collapsing"
  }, [_vm._v("\n          Actions\n        ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui red basic cancel inverted button"
  }, [_c('i', {
    staticClass: "remove icon"
  }), _vm._v("\n        No\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui icon cancel button"
  }, [_c('i', {
    staticClass: "delete icon"
  }), _vm._v(" Close\n      ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5dd75460"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/Users.vue
// module id = 742
// module chunks = 1